/**
 * Created by staffanrantzow on 14/06/16.
 */

import TaxkeyEntity from './taxkey-entity';
import axios from 'axios';
import store from 'store';
import { setTaxkeys } from 'redux/modules/taxkeys/index';
import { setLoggedInInvoiceUserTaxKeys } from 'redux/modules/invoice/index';

class TaxkeyService {

  hydrate (taxkey) {
    return new TaxkeyEntity(
      taxkey.id,
      taxkey.attributes.active,
      taxkey.attributes.taxkey_name,
      taxkey.attributes.taxkey_value,
      taxkey.attributes.tax_amount,
      taxkey.attributes.payroll_tax,
      taxkey.attributes.fee,
      taxkey.attributes.fee_express,
      +taxkey.attributes.discount
    );
  }

  hydrateCollection (data) {
    var taxkeys = [];

    for (let taxkey of data) {
      taxkeys.push(this.hydrate(taxkey));
    }

    return taxkeys;
  }

  storeTaxkeys (data) {
    let taxkeyData = [];

    for (let obj of data) {
      taxkeyData.push(obj);
    }

    let taxkeys = this.hydrateCollection(taxkeyData);

    store.dispatch(setTaxkeys(taxkeys));
    store.dispatch(setLoggedInInvoiceUserTaxKeys(taxkeys));
  }

  getWorkersTaxkeys (workerIds) {
    return axios.get('backend://workers/taxkeys?workerids=' + workerIds)
      .then((response) => {
        return response.data.map(item => {
          return {
            userId: item.user_id,
            taxkeys: this.hydrateCollection(item.taxkeys)
          };
        });
      });
  }

  getWorkerTaxkeys (workerId) {
    return axios.get('backend://workers/' + workerId + '/taxkeys')
      .then((response) => {
        return this.hydrateCollection(response.data.data);
      });
  }

  get (userId) {
    if (localStorage.getItem('oauth')) {
      return axios.get('backend://users/' + userId + '/taxkeys')
        .then((response) => {
          this.storeTaxkeys(response.data.data);
        });
    }

    return Promise.resolve();
  }
}

export default new TaxkeyService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/taxkeys/taxkey-service.js
 **/